module.exports = __webpack_public_path__ + "assets/1792649897182/img/ppt-icon.06e1fab7.png";